import { Link } from '@optimus-web/core';
import { DateTimeCell, DateTimeCellProps } from '../../../../common';

interface ReservationDateTimeUtcProps extends DateTimeCellProps {
    onClick: () => void;
}

export const ReservationDateTimeUtc = ({ utcString, onClick }: ReservationDateTimeUtcProps) => (
    <Link onClick={onClick} inherit>
        <DateTimeCell utcString={utcString} />
    </Link>
);
